import * as SELECTORS from '@/constants/selectors'
import styles from './Main.module.scss'

export default function Main({ children, className, ...props }) {
  return (
    <main
      id={SELECTORS.MAIN_CONTENT_ID}
      tabIndex="-1"
      className={[styles.main, className].join(' ')}
      data-cy="main-content-area"
      {...props}
    >
      {children}
    </main>
  )
}
